define(
  'modules/tracking',
  [
    'modules/utils'
  ],
  function (
    M_Utils
  ) {
    'use strict';

    function getDataLayer () {
      return Object.assign({}, window.tngaDataLayer)
    }

    function trackPageLoad () {
      
      var dataLayer = getDataLayer();

      dataLayer = Object.assign(dataLayer, {
        page: Object.assign({}, dataLayer.page, {
          category: 'promotions',
          subCategory: '',
          sectionlv1: 'new-cars',
          sectionlv2: 'nx',
          sectionlv3: 'experience'
        }),
        product: [{
          category: 'cars',
          subCategory: 'new-cars',
          productInfo: {
            modelName: 'nx'
          }
        }]
      });

      return track(dataLayer);
    }

    function trackPageView (path) {
      return // no longer required
    }

    function trackEvent (action, label) {

      var dataLayer = getDataLayer();

      dataLayer.event = {
        name: "componentevent",
        componentName: "experience",
        componentGroup: "new-cars",
        action: action,
        label: label
      }

      return track(dataLayer);
    }

    function track (dataLayer) {

      window.tngaDataLayer = dataLayer;

      if (Array.isArray(window.dataLayer)) {

        window.dataLayer.push({
          event: 'componentevent'
        });
      }
    }

    return {
      trackPageLoad: trackPageLoad,
      trackPageView: trackPageView,
      trackEvent: trackEvent
    }
});
